import get from "lodash-es/get";
import React from "react";
import { formatVolume } from "src/services/number.service";
import { toTitleCase } from "src/services/string.service";
import globalTheme, { media } from "src/theme";
import { IProduct } from "src/types/product";
import styled from "styled-components";

import { ILayout, ITheme } from "../types";

const Wrapper = styled.p<ILayout>`
  font-size: ${globalTheme.fontSizes.tiny};
  color: ${globalTheme.colors.grey};
  max-width: 230px;

  ${media.tablet} {
    ${({ layout }: ILayout): string | false =>
      layout === "productPage" &&
      `
    max-width: initial;
    text-align: left;
    `}
  }
`;

interface IProps extends ITheme, ILayout {
  product: IProduct;
}

const ProductDetails = ({
  product,
  theme,
  layout,
}: IProps): JSX.Element | null => {
  if (
    product.productSubFamily ||
    product.originCountry ||
    product.originRegion ||
    product.volume ||
    product.reference
  ) {
    return (
      <Wrapper layout={layout}>
        {toTitleCase(get(product, "productSubFamily", "")) +
          ((!!get(product, "productSubFamily") && ", ") || "") +
          toTitleCase(get(product, "originCountry", "")) +
          ((!!get(product, "originCountry") && " / ") || "") +
          toTitleCase(get(product, "originRegion", "")) +
          ((!!get(product, "originRegion") && ", ") || "") +
          (get(product, "volume") && formatVolume(get(product, "volume"))) +
          ((!!get(product, "volume") && !!get(product, "reference") && ", ") ||
            "") +
          ((!!get(product, "reference") && "Ref: ") || "") +
          get(product, "reference", "")}
      </Wrapper>
    );
  }

  return null;
};

export default ProductDetails;
